export default "__VITE_ASSET__0517b177__"